import React, { Component } from 'react';
import styled, { css } from 'styled-components';

import MapMobile from '../../images/art/Mobile.png';
import MapDesktop from '../../images/art/Tablet.png';
import MapTabletAndMobileLandscape from '../../images/art/Tablet.png';
import { palette, breakpoints } from '../../constants/styles';
import Graphic from './Graphic';
import Text from '../shared/Text';

const StyledMap = styled.div`
  position: relative;
  margin-top: -40px;
  z-index: -1;

  margin-bottom: 50px;

  ${breakpoints.tablet} {
    left: -14px;
  }

  ${breakpoints.desktop} {
    left: 80px;
  }
`;

const MapText = styled.span`
  position: absolute;
  top: 0;
  left: 0;

  color: ${palette.darkerGray};
  font-size: 1.2em;
  letter-spacing: 0;
  line-height: 25px
  margin-top: 10px;

  ${breakpoints.mobileLandscape} {
    margin-top: 0px;
  }

  ${breakpoints.desktop} {
    font-size: 1.6em;
    line-height: 35px
  }

  ${({ styles }) => styles}
`;

const textStyles1 = css`
  top: 142px;
  left: 75px;

  ${breakpoints.mobileLandscape} {
    top: 170px;
    left: 90px;
    width: 18rem;
  }

  ${breakpoints.desktop} {
    top: 205px;
    left: 115px;
  }
`;

const textStyles2 = css`
  top: 303px;
  right: 70px;

  ${breakpoints.mobileLandscape} {
    top: 350px;
    left: 80px;
    width: 180px;
  }

  ${breakpoints.desktop} {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: flex-end;
    top: 430px;
    left: 45px;
    width: 270px;
  }
`;

const textStyles3 = css`
  top: 403px;
  left: 70px;

  ${breakpoints.mobileLandscape} {
    top: 473px;
    left: 75px;
  }

  ${breakpoints.desktop} {
    top: 578px;
    left: 101px;
    width: 18rem;
  }
`;

const mapStyles = css`
  width: 280px;

  ${breakpoints.mobileLandscape} {
    width: 340px;
  }

  ${breakpoints.desktop} {
    width: 415px;
    margin-right: 175px;
  }
`;

const StyledMapText1 = css`
  line-height: 15px;

  ${breakpoints.desktop} {
    width: 180px;
  }
`;

const StyledMapText2 = css`
  line-height: 15px;

  ${breakpoints.desktop} {
    width: 190px;
  }
`;

const StyledMapText3 = css`
  line-height: 15px;

  ${breakpoints.desktop} {
    width: 240px;
  }
`;

class Map extends Component {
  state = { val: null };

  render() {
    return (
      <StyledMap>
        <Graphic
          mP={MapMobile}
          mL={MapTabletAndMobileLandscape}
          tP={MapTabletAndMobileLandscape}
          tL={MapTabletAndMobileLandscape}
          d={MapDesktop}
          l={MapDesktop}
          styles={mapStyles}
        />
        <MapText styles={textStyles1}>
          <Text bold>Cuéntanos sobre ti</Text>
          <Text color="#606060" styles={StyledMapText1} type="subtitle2" light>
            Responde unas preguntas para hacer tu plan a la medida
          </Text>
        </MapText>
        <MapText styles={textStyles2}>
          <Text bold align="right">
            Recibe tu plan
          </Text>
          <Text color="#606060" styles={StyledMapText2} type="subtitle2" light align="right">
            Conoce cómo están tus finanzas y cómo mejorarlas paso a paso
          </Text>
        </MapText>
        <MapText styles={textStyles3}>
          <Text bold>Naveguemos juntos</Text>
          <Text color="#606060" styles={StyledMapText3} type="subtitle2" light>
            Si así lo eliges, pondremos tu plan en marcha y estaremos ahí para ti en cada paso
          </Text>
        </MapText>
      </StyledMap>
    );
  }
}

export default Map;
